export default __webpack_public_path__ + "static/onboardingPlayBar-1b0746f98a2b331e829346df33e77ad2.png";